import { useCallback, createContext, useContext, useRef } from 'react';
import { shallowEqual } from 'react-redux';
import { MailActions, useActions, useAppSelector } from '@web-common/state/createStore';
import useCreateCallbackForEvent from './useCreateCallbackForEvent';
import { tabId } from '@web-common/state/reducer/mailTabReducer';
import { getCustomerSliceIdByType } from '@web-mail/utils/slice';
export const ctSliceContext = createContext(tabId.readCustomer);
export const SdSliceContext = createContext(tabId.subordinate);
export const useState2CustomerSlice = (stateName, reducerName, sliceId) => {
    const selectedCustomerTab = useAppSelector(state => state.mailReducer.selectedCustomerTab);
    const sliceId_context = getCustomerSliceIdByType(selectedCustomerTab);
    const resSliceId = sliceId ? sliceId : sliceId_context;
    const state = useAppSelector(state => state.mailReducer.customer[resSliceId][stateName], shallowEqual);
    const reducer = useActions(MailActions)[reducerName || 'doUpdateSliceAny_cm'];
    const stateRef = useRef(state);
    stateRef.current = state;
    const setter = useCallback((val) => {
        if (reducer) {
            if (typeof val === 'function') {
                reducer(reducerName ? { sliceId: resSliceId, data: val(stateRef.current) } : { sliceId: resSliceId, name: stateName, data: val(stateRef.current) });
            }
            else {
                reducer(reducerName ? { sliceId: resSliceId, data: val } : { sliceId: resSliceId, name: stateName, data: val });
            }
        }
        else {
            console.error('REDUCER IS NOT VALID', stateName, reducerName);
        }
    }, [reducer, stateName, reducerName, resSliceId]);
    const setterRef = useCreateCallbackForEvent(setter);
    return [state, setterRef];
};
export const useState2SubordinateSlice = (stateName, reducerName, sliceId) => {
    const sliceId_context = useContext(SdSliceContext);
    const resSliceId = sliceId ? sliceId : sliceId_context;
    const state = useAppSelector(state => state.mailReducer.subordinate[resSliceId][stateName], shallowEqual);
    const reducer = useActions(MailActions)[reducerName || 'doUpdateSliceAny_sd'];
    const stateRef = useRef(state);
    stateRef.current = state;
    const setter = useCallback((val) => {
        if (reducer) {
            if (typeof val === 'function') {
                reducer(reducerName ? { sliceId: resSliceId, data: val(stateRef.current) } : { sliceId: resSliceId, name: stateName, data: val(stateRef.current) });
            }
            else {
                reducer(reducerName ? { sliceId: resSliceId, data: val } : { sliceId: resSliceId, name: stateName, data: val });
            }
        }
        else {
            console.error('REDUCER IS NOT VALID', stateName, reducerName);
        }
    }, [reducer, stateName, stateName, resSliceId]);
    const setterRef = useCreateCallbackForEvent(setter);
    return [state, setterRef];
};
